import { Button, Flex, Text } from '@chakra-ui/react'
import { userListContext } from 'BrokerTsLib/src/context'
import type { OrganizationUnit, UserPagedQuery } from 'BrokerTsLib/src/dtos'
import { useSearchUsers } from 'BrokerTsLib/src/hooks/useUser'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { TableSection } from '@/components/Section/TableSection'
import { useAuth } from '@/context/AuthContext'
import { Add } from '@/icons'

import {
  UserList,
  UserListEmailColumn,
  UserListNameColumn,
  UserListRolesColumn,
  UserListTypeColumn,
  UserListUserNameColumn,
  UserListValidityColumn
} from '../user/UserList'

const defaultPageSize = 10
export const OrganizationUserList = ({
  organization,
}: {
  organization: OrganizationUnit
}) => {
  const [filter, setFilter] = useState<UserPagedQuery>({
    organizationUnitId: organization.id,
    name: '',
    showInvalid: false,
    pageIndex: 1,
    pageSize: defaultPageSize,
  })
  const { user } = useAuth()

  const { data, refetch, isLoading } = useSearchUsers(filter)
  const items = data?.data.items ?? []

  useEffect(() => {
    setFilter((value) => ({
      ...value,
      organizationUnitId: organization.id,
      name: '',
      showInvalid: false,
      pageIndex: 1,
    }))
  }, [organization.id])

  return (
    <TableSection
      cardHeaderProps={{ py: 2 }}
      sectionTitle={
        <Flex justifyContent={'space-between'}>
          <Text>Uživatelé</Text>
          {user?.allowEditOrganizationStructure &&
            <Button
              colorScheme="primary"
              size="xs"
              variant="link"
              as={Link}
              to={`/organization/${organization.id}/createUser`}
            >
              Vytvořit nového uživatele
              <Add />
            </Button>}
        </Flex>
      }
      wide
    >
      <userListContext.Provider
        value={{
          loading: isLoading,
          totalCount: data?.data?.totalCount ?? 0,
          currentPage: filter.pageIndex,
          pageSize: defaultPageSize,
          filter: filter,
          setCurrentPage: (p: number) => setFilter((f) => ({ ...f, pageIndex: p })),
          setPageSize: () => { },
          updateFilter: setFilter,
          reload: () => refetch(),
        }}
      >
        {/* <UserListFilter p={4} /> */}
        <UserList
          users={items ?? []}
          columnsDefinition={[
            UserListTypeColumn,
            UserListNameColumn,
            UserListUserNameColumn,
            UserListEmailColumn,
            UserListValidityColumn,
            UserListRolesColumn,
          ]}
        />
        {/* <Pagination context={userListContext} /> */}
      </userListContext.Provider>
    </TableSection>
  )
}
